import { toast } from 'sonner';

export const appToast = {
  success(_message: string) {
    // Success is reflected in UI state; only surface errors via toast.
  },
  error(message: string) {
    toast.error(message);
  },
  info(message: string) {
    toast(message);
  },
};
